import React from "react";
import { connect } from "react-redux";
import classnames from "classnames";
import KitsDropDown from "../kits/kits-dropdown";
import * as actions from "../../actions/actions";
import { KITS_FLOW } from "../../reducers/kits";

const IconProSaveForLater = ({
    kitsFetch,
    icon,
    iconSaved,
    initialized,
    loggedIn,

    downloadShowAuth,
    dropdownShowing,
    kitsShowDropdown,
    kitsHideDropdown
}) => {
    let dropdownRef = React.useRef(null);

    let dismiss = React.useCallback(() => kitsHideDropdown(), [
        kitsHideDropdown
    ]);

    React.useEffect(() => {
        if (!initialized && loggedIn) {
            kitsFetch();
        }
        let htmlEl = document.querySelector("html");
        let listener = evt => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(evt.target)
            ) {
                dismiss();
            }
        };
        if (dropdownShowing) {
            htmlEl.addEventListener("click", listener);
        }
        return () => {
            let htmlEl = document.querySelector("html");
            htmlEl.removeEventListener("click", listener);
        };
    }, [dropdownRef, dismiss, dropdownShowing]);

    let dropdown,
        dropdownContainerClasses = "kit-container";

    if (dropdownShowing) {
        dropdown = <KitsDropDown iconId={icon.id} />;
        dropdownContainerClasses = classnames(
            dropdownContainerClasses,
            "visible"
        );
    }

    let onButtonClick;
    if (loggedIn) {
        if (dropdownShowing) {
            onButtonClick = kitsHideDropdown;
        } else {
            onButtonClick = kitsShowDropdown;
        }
    } else {
        onButtonClick = downloadShowAuth.bind(null, KITS_FLOW);
    }

    let buttonClass = classnames("button", { black: iconSaved });
    let buttonText = iconSaved ? "Saved" : "Save for Later";

    return (
        <div ref={dropdownRef} className="kit-share-container">
            <div className="kit-wrapper">
                <div
                    data-test-id="kits-save-for-later"
                    className={buttonClass}
                    onClick={onButtonClick}
                >
                    {buttonText}
                </div>
                <div className={dropdownContainerClasses}>{dropdown}</div>
            </div>
        </div>
    );
};

const mapStateToProps = (state, ownProps) => {
    let { kits, user } = state;
    let { savedIconIds, dropdownShowing } = kits;
    let iconSaved = !!savedIconIds[Number(ownProps.icon.id)];
    let initialized = Object.keys(kits.all).length;
    let loggedIn = !user || !user.is_anonymous;

    return {
        iconSaved,
        user,
        initialized,
        loggedIn,
        dropdownShowing
    };
};

export default connect(mapStateToProps, {
    kitsFetch: actions.kitsFetch,
    downloadShowAuth: actions.downloadShowAuth,
    kitsShowDropdown: actions.kitsShowDropdown,
    kitsHideDropdown: actions.kitsHideDropdown
})(IconProSaveForLater);
